export default __webpack_public_path__ + "static/media/7863B231-AD0C-44C5-BAA5-25E9D2CB25B1 - Aditya Sinha.68cffb1a.jpeg";